// export const API_BASE = "http://localhost:3001";
export const API_BASE = "https://trivia-scoring-be.onrender.com";
